import React from "react" /**/;
import { MembreTableRow } from "./members_table_row";
import { RolesModal } from "../roles_modal/roles_modal";
import { PartnerRolesModal } from "../roles_modal/roles_modal_partner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export function MembersTable({
  memberships,
  currentUserMembership,
  currentFirm,
}) {
  const new_member_path = "/members/new";

  // info dialog
  const [visibleDialog, setVisibleDialog] = React.useState(false);
  const DialogComponent = currentUserMembership.side === "provider" ? PartnerRolesModal : RolesModal;

  return (
    <>
      <div className="members__header">
        <span className="participants-all-header__title">
          {window.i18n.t('members.headers.teamName', { name: currentFirm?.name })}
        </span>

        <a className="header_btn_participants_link_btn" href={new_member_path}>
          <span className="header-link-participants__link__btn">
            {window.i18n.t('members.buttons.addMember')}
          </span>
        </a>
      </div>
      <header className="members-table-row members-table-row--6col members-table-row--header">
        <div className="members-table-row__col">
          <span className="members-table-row__title">{window.i18n.t('members.headers.collaborators')}</span>
        </div>
        <div className="members-table-row__col members-table-row__col--start">
          <span className="members-table-row__title">{window.i18n.t('members.headers.role')}</span>
        </div>

        <div className="members-table-row__col members-table-row__col--start">
          <span className="members-table-row__title">{window.i18n.t('members.headers.email')}</span>
        </div>

        <div className="members-table-row__col members-table-row__col--center">
          <span className="members-table-row__title">{window.i18n.t('members.headers.mobile')}</span>
        </div>
        <div className="members-table-row__col members-table-row__col--center">
          <span className="members-table-row__title">{window.i18n.t('members.headers.phone')}</span>
        </div>
        <div className="members-table-row__col__end members-table-row__col--center">
          <span className="members-table-row__title">
            {window.i18n.t('members.headers.receivesRequests')}
          </span>
        </div>
        <div className="members-table-row__col table-row__col--center">
          <span className="members-table-row__title">{window.i18n.t('members.headers.role')}
          <a className="px-2 py-1" onClick={() => setVisibleDialog(true)}>
            <FontAwesomeIcon icon={faInfoCircle} color="#F38047" size={20} />
          </a>
          </span>
        </div>
        <div className="members-table-row__col table-row__col--start">
          <span className="members-table-row__title"></span>
        </div>
      </header>
      <div>
        {memberships.map((membership) => (
          <MembreTableRow
            key={membership.id}
            membership={membership}
            currentUserMembership={currentUserMembership}
          />
        ))}
      </div>
      <DialogComponent show={visibleDialog} handleClose={() => setVisibleDialog(false)} />
    </>
  );
}
